import React from 'react';
import { DownloadOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import PropTypes from 'prop-types';
import BorderlessButton from './BorderlessButton';

export default function SliderDownloadButton({
  onDownload,
  loading,
  style = {},
}) {
  if (loading) {
    return (
      <Spin className="slider-download-button" />
    );
  }
  return (
    <BorderlessButton
      className="slider-download-button"
      style={style}
      iconNode={<DownloadOutlined style={{ marginLeft: 0, fontSize: 16 }} />}
      onClick={onDownload}
    />
  );
}

SliderDownloadButton.propTypes = {
  onDownload: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  style: PropTypes.shape({}),
};

SliderDownloadButton.defaultProps = {
  loading: false,
  style: {},
};
